import { render, staticRenderFns } from "./bindMerchant.vue?vue&type=template&id=f2be67b2&scoped=true&"
import script from "./bindMerchant.vue?vue&type=script&lang=js&"
export * from "./bindMerchant.vue?vue&type=script&lang=js&"
import style0 from "./bindMerchant.vue?vue&type=style&index=0&id=f2be67b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2be67b2",
  null
  
)

export default component.exports